import {
  PostMasterCarInterface,
  DeleteMasterCarInterface,
  UpdateMasterCarInterface,
} from '@/data/payload/contracts/MasterCarRequest'

export class UpdateMasterCarRequest implements UpdateMasterCarInterface {
  private name: string
  private trainingActive: boolean
  private sopActive: boolean
  private imageCoverId: number
  private imageThumbnailId: number
  private imageLogoId: number
  private tag: string

  constructor(
    name: string,
    trainingActive: boolean,
    sopActive: boolean,
    imageCoverId: number,
    imageThumbnailId: number,
    imageLogoId: number,
    tag: string
  ) {
    this.name = name
    this.trainingActive = trainingActive
    this.sopActive = sopActive
    this.imageCoverId = imageCoverId
    this.imageThumbnailId = imageThumbnailId
    this.imageLogoId = imageLogoId
    this.tag = tag
  }
  public toJSON() {
    const data = {
      name: this.name,
      training_active: this.trainingActive,
      sop_active: this.sopActive,
      image_cover_id: this.imageCoverId,
      image_thumbnail_id: this.imageThumbnailId,
      image_logo_id: this.imageLogoId,
      tag: this.tag,
    }
    return JSON.stringify({
      data,
    })
  }
}
export class DeleteMasterCarRequest implements DeleteMasterCarInterface {
  private ids: number

  constructor(ids: any) {
    this.ids = ids
  }
  public toJSON() {
    const Ids = this.ids
    return JSON.stringify({
      Ids,
    })
  }
}

export class MasterCarApiRequest implements PostMasterCarInterface {
  private name: string
  private trainingActive: boolean
  private sopActive: boolean
  private imageCoverId: number
  private imageThumbnailId: number
  private imageLogoId: number
  private tag: string

  constructor(
    name: string,
    trainingActive: boolean,
    sopActive: boolean,
    imageCoverId: number,
    imageThumbnailId: number,
    imageLogoId: number,
    tag: string
  ) {
    this.name = name
    this.trainingActive = trainingActive
    this.sopActive = sopActive
    this.imageCoverId = imageCoverId
    this.imageThumbnailId = imageThumbnailId
    this.imageLogoId = imageLogoId
    this.tag = tag
  }

  public toJSON() {
    const data = {
      name: this.name,
      training_active: this.trainingActive,
      sop_active: this.sopActive,
      image_cover_id: this.imageCoverId,
      image_thumbnail_id: this.imageThumbnailId,
      image_logo_id: this.imageLogoId,
      tag: this.tag,
    }

    return JSON.stringify({
      data,
    })
  }
}
